import { render, staticRenderFns } from "./EditPhoneNumberModal.vue?vue&type=template&id=b220299e&"
import script from "./EditPhoneNumberModal.vue?vue&type=script&lang=js&"
export * from "./EditPhoneNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports